import { onBeforeUnmount, onMounted, ref } from 'vue'
import checkAppVersion from '@/helpers/checkAppVersion'

const useCheckAppVersion = (interval = 180000) => {
  const intervalKey = ref(null)

  onMounted(() => {
    checkAppVersion()

    intervalKey.value = setInterval(() => {
      checkAppVersion()
    }, interval)
  })

  onBeforeUnmount(() => {
    if (intervalKey.value) {
      clearInterval(intervalKey.value)
    }
  })

  return { checkAppVersion }
}

export default useCheckAppVersion
